/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import ServiceRegistry from "bundle/util/ServiceRegistry";
import { InternalCallbackTypes } from "common/constants/CallbackTypes";

const _formatSearchData = searchData => ({
    currentResult: {
        pageNumber: searchData.currResult ? searchData.currResult.pageNum : undefined,
        index: searchData.currResult ? searchData.currResult.index : undefined,
    },
    totalResults: searchData.totalResults,
    status: searchData.status,
});

class SearchApi {
    searchId;

    searchObject;

    updateSearchData = (searchId, searchObj) => {
        this.searchId = searchId;
        this.searchObject = searchObj;
    }

    getCurrentSearchId = () => this.searchId;

    onResultsUpdate = () => {
        if (this.searchObject) {
            const callbackService = ServiceRegistry.getService("CallbackService");
            if (callbackService.hasCallback(InternalCallbackTypes.ON_SEARCH_RESULTS_UPDATE)) {
                const callbackFn = callbackService.getCallback(InternalCallbackTypes.ON_SEARCH_RESULTS_UPDATE);
                return this.searchObject.onResultsUpdate(data => callbackFn(_formatSearchData(data)));
            }
        }
        return false;
    };

    next = () => {
        if (this.searchObject) {
            return this.searchObject.next();
        }
        return false;
    };

    previous = () => {
        if (this.searchObject) {
            return this.searchObject.previous();
        }
        return false;
    };

    clear = () => {
        if (this.searchObject) {
            const result = this.searchObject.clear();
            this.searchObject = undefined;
            return result;
        }
        return false;
    };
}

const searchApi = new SearchApi();
export default searchApi;
